import { render, staticRenderFns } from "./reclamo-resumen.vue?vue&type=template&id=1d4d01f7&"
import script from "./reclamo-resumen.vue?vue&type=script&lang=ts&"
export * from "./reclamo-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports